import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

import { getGroupedSubTopics } from '../../../store/SubTopicSlice';
import QuizHistoryViewQuestions from '../ManageSubmissionQuestions/QuizHistoryViewQuestions';

const ViewQuestion: React.FC = () => {
  const params = useParams();
  const dispatch = useDispatch();

  const urlStringPattern = params.pattern || '';
  const urlStringPatternDivided = urlStringPattern.split('_').reverse();
  const subTopicId = urlStringPatternDivided[0] || '';

  useEffect(() => {
    dispatch(getGroupedSubTopics({ subTopicId }));
  }, []);

  return <QuizHistoryViewQuestions viewNavBar />;
};

export default ViewQuestion;
